cockpitApp.provider('logsProvider', [
  function () {
    this.$get = ['cockpitClient',
      function (cockpitClient) {
        return {
          logInteraction: logInteraction
        };

        function logInteraction(requestParameters) {
          return cockpitClient.logInteraction(requestParameters);
        }
      }
    ];
  }
]);
